import { useContext, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import { MdArrowForward, MdCheckCircle } from 'react-icons/md';
import { AppContext } from '../App';
import { hospiumProducts } from '../HospiumContent';
import logoWorded from '../assets/logo_worded.png';

export default function HomeSlider() {
  const sliderRef = useRef(null);
  const appContext = useContext(AppContext);

  useEffect(() => {
    const slider = sliderRef.current;
    const stopPropagation = (event) => event.stopPropagation();
    if (slider) {
      slider.addEventListener('touchstart', stopPropagation);
      slider.addEventListener('touchmove', stopPropagation);
      slider.addEventListener('touchend', stopPropagation);
    }
    return () => {
      if (slider) {
        slider.removeEventListener('touchstart', stopPropagation);
        slider.removeEventListener('touchmove', stopPropagation);
        slider.removeEventListener('touchend', stopPropagation);
      }
    };
  }, []);

  return (
    <section className="HospiumHero" ref={sliderRef}>
      <Slider dots infinite autoplay autoplaySpeed={6500} speed={700} arrows={false} pauseOnHover={false}>
        {hospiumProducts.map((product, index) => (
          <div key={product.key}>
            <article className="HospiumHeroSlide" style={{ backgroundImage: `url(${product.image})` }}>
              <div className="HospiumHeroShade">
                <div className="container HospiumHeroContent">
                  <img className="HospiumHeroLogo" src={logoWorded} alt="Hospium" />
                  <div className="HospiumEyebrow">Smarter Care, Better Outcomes · 0{index + 1}</div>
                  <h1>{product.name}</h1>
                  <h2>{product.label}</h2>
                  <p>{product.short}</p>
                  <div className="HospiumHeroPoints">
                    {product.points.slice(0, 2).map((point) => <span key={point}><MdCheckCircle /> {point}</span>)}
                  </div>
                  <div className="HospiumHeroActions">
                    <button className="btn btn-primary btn-padded btn-rounded" onClick={() => appContext.navTo({ item: 'services' })}>View products <MdArrowForward /></button>
                    <button className="btn btn-outline-light btn-padded btn-rounded" onClick={() => appContext.navTo({ item: 'contact_us' })}>Place inquiry</button>
                  </div>
                </div>
              </div>
            </article>
          </div>
        ))}
      </Slider>
    </section>
  );
}
